import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";
import { formatCurrency } from "@/utils";

interface MoneyProps {
  /** So'mdagi summa. */
  value?: number | null;
  className?: string;
}

/**
 * Pul summasi — YAGONA formatlash joyi.
 *
 * Eski ilovada ikkita ro'yxatda `$` qotib qolgan edi, garchi butun tizim
 * so'mda ishlasa ham. Bu komponent umumiy formatlagichni va tarjima
 * qilingan valyuta yorlig'ini birga olib yuradi, ya'ni belgini qo'lda
 * yozadigan joy qolmaydi.
 */
export const Money = ({ value, className }: MoneyProps) => {
  const { t } = useTranslation();

  return (
    <span className={cn("whitespace-nowrap tabular-nums", className)}>
      {formatCurrency(value, "space")} {t("COMMON.CURRENCY")}
    </span>
  );
};
